import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Stack, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DivisionRegionEditorTab } from 'src/features/general/enquete-create/components/tab-containers/shared-tabs/division-region-editor-tab/components/DivisionRegionEditorTab';
import { RespondentTab } from 'src/features/general/enquete-create/components/tab-containers/shared-tabs/respondent-tab/components/RespondentTab';
import { SurveyOwnerTab } from 'src/features/general/enquete-create/components/tab-containers/shared-tabs/survey-owner-tab/components/SurveyOwnerTab';
import { TemporaryOrganizationTab } from 'src/features/general/enquete-create/components/tab-containers/shared-tabs/temporary-organization/components/TemporaryOrganizationTab';
import { TAB_VALUE, TabValue } from 'src/features/general/enquete-create/constants';
import { useTabs } from 'src/features/general/enquete-create/hooks/useTabs';
import { usePermission } from 'src/hooks/usePermission';
import { RootState, useAppSelector } from 'src/redux/store';
import { RespondentManagerTab } from '../../shared-tabs/respondent-manager-tab/RespondentManagerTab';
import { SpecialQuestionCompliaTab } from './tabs/question-and-answer/components/SpecialQuestionCompliaTab';

export interface SpecialCompliaTabContainerProps {
  id: string | undefined;
  selectedTabValue: TabValue;
}

export const SpecialCompliaTabContainer: React.FC<SpecialCompliaTabContainerProps> = (props) => {
  const { id, selectedTabValue } = props;
  const { t } = useTranslation();
  const { tabValue, handleChangeTab } = useTabs(selectedTabValue);
  const enqueteData = useAppSelector((state: RootState) => state.enqueteCreate.enqueteData);
  const { isRespondentManagerOnly } = usePermission();

  return (
    <TabContext value={tabValue}>
      <TabList onChange={handleChangeTab}>
        <Tab label={t('enqueteCreate.tab.question')} value={TAB_VALUE.QUESTION} disabled={isRespondentManagerOnly} />
        <Tab label={t('enqueteCreate.tab.question5')} value={TAB_VALUE.QUESTION5} disabled={isRespondentManagerOnly} />
        <Tab label={t('enqueteCreate.tab.respondentList')} value={TAB_VALUE.RESPONDENT} disabled={id === undefined} />
        <Tab label={t('enqueteCreate.tab.ownerList')} value={TAB_VALUE.OWNER} disabled={id === undefined || isRespondentManagerOnly} />
        <Tab
          label={t('enqueteCreate.tab.respondentManagerList')}
          value={TAB_VALUE.RESPONDENT_MANAGER}
          disabled={id === undefined || isRespondentManagerOnly}
        />
        <Tab
          label={t('enqueteCreate.tab.divisionRegionEditor')}
          value={TAB_VALUE.DIVISION_REGION_EDITOR}
          disabled={id === undefined || isRespondentManagerOnly}
        />
        <Tab
          label={t('enqueteCreate.tab.temporaryOrganizationManagement')}
          value={TAB_VALUE.TEMPORARY_ORGANIZATION}
          disabled={id === undefined || isRespondentManagerOnly}
        />
      </TabList>
      <TabPanel value={TAB_VALUE.QUESTION}>
        <Stack spacing={2}>
          <SpecialQuestionCompliaTab type={TAB_VALUE.QUESTION}/>
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.QUESTION5}>
        <Stack spacing={2}>
          <SpecialQuestionCompliaTab type={TAB_VALUE.QUESTION5}/>
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.RESPONDENT}>
        <Stack spacing={1}>
          <RespondentTab surveyDetailId={enqueteData.surveyDetailId} answerUnit={enqueteData.surveyDetail?.surveyHeader?.answerUnit} />
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.OWNER}>
        <Stack spacing={1}>
          <SurveyOwnerTab respondentRequestId={enqueteData.id} surveyDetailId={enqueteData.surveyDetailId} />
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.RESPONDENT_MANAGER}>
        <Stack spacing={1}>
          <RespondentManagerTab surveyDetailId={enqueteData.surveyDetailId} />
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.DIVISION_REGION_EDITOR}>
        <Stack spacing={1}>
          <DivisionRegionEditorTab surveyDetailId={enqueteData.surveyDetailId} />
        </Stack>
      </TabPanel>
      <TabPanel value={TAB_VALUE.TEMPORARY_ORGANIZATION}>
        <Stack spacing={1}>
          <TemporaryOrganizationTab surveyDetailId={enqueteData.surveyDetailId} />
        </Stack>
      </TabPanel>
    </TabContext>
  );
};
